import React, { useState, useEffect, useCallback } from 'react';

import { Tabs, Card, Button, message } from 'antd';
import PropertyLevelContacts from './PropertyLevelContacts'
import ChainLevelContacts from './ChainLevelContacts'
import './index.css';
import PageContainer from '../../../CSIComponents/PageContainer';
import { getContactPerson } from '../../../../services/contactperson';
import { LocalPersistence } from '../../../../factories';
import { sessionType } from '../../../../interfaces';
import Loading from '../../../Loading';
import { getOTACodes } from '../../../../services/common';

const { TabPane } = Tabs;

interface contactPersonDetailsTypes {
    propertylevelcontacts?:Array<object>,
    chainlevelcontacts?:Array<object>,
}

interface optionsType{
  id: number
  codeType: string,
  codeValue: string,
  codeName: string,
  subCat: string | number |null
}

const EnvironmentalImpact = () => {
  const [isEditModle, setIsEditModle] = useState<boolean>(false)
  const [loadingFlag, setLoadingFlag] = useState<boolean>(true)
  const [refreshPage, setRefreshPage] = useState<number>(0)
  const [typeData, setTypeData] = useState<optionsType[]>([])
  const [businessTypeList, setBusinessTypeList] = useState<optionsType[]>([])
  const [contactPersonDetails, setContactPersonDetails] = useState<contactPersonDetailsTypes>({})
  
  const getContactPersonDetails = useCallback(async()=>{
    try {
      const get_session = new LocalPersistence('session')
      const session: sessionType = await get_session.getSessionPersistence()
      const { supplier, propertyId } = session || {} 
      const res = await getContactPerson(supplier, propertyId)
      if(res.result.success){
        if(!res?.property?.contactperson?.propertylevelcontacts?.length){
          res.property.contactperson.propertylevelcontacts = [{}]
        }
        if(!res?.property?.contactperson?.chainlevelcontacts?.length){
          res.property.contactperson.chainlevelcontacts = [{}]
        }
        setContactPersonDetails(res?.property?.contactperson)
      }else{
        message.error({
          content: res?.error[0]?.message || 'Query failed'
        });
      }      
      setLoadingFlag(false)
    } catch (error) {
      setLoadingFlag(false)
      return error
    }
  },[])
    
  const getTypeList = useCallback(async () => {
    let res = await getOTACodes('CON', '')
    let rest = res?.otacodes || []
    setTypeData(rest)
  },[])

  const getBusinessType = useCallback(async () => {
    let res = await getOTACodes('BUT', '')
    let rest = res?.otacodes || []
    setBusinessTypeList(rest)
  },[])
  
    useEffect(() => {
      getTypeList();
      getBusinessType();
      getContactPersonDetails();
      return ()=>{
        setIsEditModle(false)
        setLoadingFlag(true)
        setContactPersonDetails({})
        setTypeData([])
      }
    },[])

    useEffect(()=>{
      getContactPersonDetails()
    },[refreshPage])

    const returnToViewModel = ()=>{
      setIsEditModle(false)
    }

    return (
      loadingFlag?<Loading type="large"/>:<PageContainer>
            <Card style={{ marginTop: -15, marginBottom: 70 }}>
                <Tabs 
                  type="card" 
                  defaultActiveKey={'1'} 
                  tabBarExtraContent={
                    isEditModle?null:<Button 
                      type='primary'
                      className="db-edit-btn"
                      onClick={ () => setIsEditModle(true) }
                      >
                        Edit
                      </Button>}>
                    <TabPane tab="Property Level Contacts" key="1" forceRender={true} disabled={isEditModle}>
                    <PropertyLevelContacts 
                      typeList={typeData} 
                      businessTypeList={businessTypeList} 
                      isEditModle={isEditModle} 
                      returnToViewModel={returnToViewModel} 
                      contactPersonDetails={contactPersonDetails}
                      refreshPage={refreshPage}
                      setRefreshPage={setRefreshPage}
                    />
                    </TabPane>
                    <TabPane tab="Chain Level Contacts" key="2" forceRender={true}  disabled={isEditModle}>
                    <ChainLevelContacts 
                      typeList={typeData} 
                      businessTypeList={businessTypeList} 
                      isEditModle={isEditModle} 
                      returnToViewModel={returnToViewModel} 
                      contactPersonDetails={contactPersonDetails}
                      refreshPage={refreshPage}
                      setRefreshPage={setRefreshPage}
                      />
                    </TabPane>
                    
                </Tabs>
            </Card>
        </PageContainer>
    )
}

export default EnvironmentalImpact;



